
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum CredentialType {
	ProductsAccessFull = 0,
	UsersAccessFull = 1,
	TeamsAccessFull = 2,
	EditTaskflowTemplates = 3,
	QueriesAccessFull = 4,
	SystemLogAccessFull = 5,
	MailTemplatesAccessFull = 6,
	QuestionnaireAccessFull = 7,
	ProductAccessLevelSales = 8,
	ProductAccessLevelSalesSenior = 9,
	ProductAccessLevelCustomerService = 10,
	SaleAgreementAccessFull = 11,
	TaskflowAccessEdit = 12,
	BetaUserAccess = 13,
	EditAccountingPlan = 14,
	CreateProductPlanManually = 15,
	StartProductPlanManually = 16,
	AccountingPlanSetupAccessFull = 17,
	CreateCreditMemo = 18,
	EditPriceAdjustments = 19,
	EditMicrosoft365 = 20,
	ExportLedgerPosts = 21,
	EditCompanyAccountingSettings = 22,
	UpdateCompanyFromCvr = 23,
	UpdateAccountingPlanStatus = 24,
	CreateFreeMicrosoft365 = 25,
	EditProductPlanSettings = 26,
	EditLedgerPosts = 27,
	EditLanguageTranslations = 28,
	EditAccountingPlanEndDate = 29,
	EditMigratedLedgerPosts = 30,
	SearchAccountingPlans = 31,
	ProductPlanCompanyTransfer = 32,
	EditProductPlanParent = 33,
	CreateInvoiceObjection = 34,
	SearchInvoiceObjections = 35,
	EditReasons = 36,
	EditSettlements = 37,
	SystemIntegration = 38,
	EditInvoiceOnHoldStatus = 39,
	ManageCompanySites = 40,
	DebtCollection = 41,
	EditInvoiceDueDate = 42,
	UpdateCompanyVatNumber = 43,
	ManageSales = 44,
	CancelApprovedOrders = 45,
	ManageCommission = 46,
	ManageCompanyFiles = 47,
	ApproveSettlement = 48,
	DeleteContracts = 49,
	EditSalesDetails = 50,
	ListOrdersWithCancellationWarnings = 51,
	AccountingsystemSendDocuments = 52,
	EditProductPlanTerminationNoticePeriod = 53,
	AccessCompanyDomains = 54,
	EditOrderSpecialConditions = 55,
	AccessDebugViews = 56,
	SyncEnvironmentData = 57,
	EditDnsRecords = 58,
	RequestRegistrarManagement = 59,
	DomainCleanUp = 60,
	DomainRedelegate = 61,
	SearchProductPlans = 62,
	ListOrdersForApproval = 63,
	DebtCollectionRegisterAndExport = 64,
	EditInvoiceInstallmentPayments = 65,
	DashbordAccessFull = 66
}
export namespace CredentialType {
	export function getKeys(): Map<CredentialType, string> {
		return new Map([[0, 'ProductsAccessFull'], [1, 'UsersAccessFull'], [2, 'TeamsAccessFull'], [3, 'EditTaskflowTemplates'], [4, 'QueriesAccessFull'], [5, 'SystemLogAccessFull'], [6, 'MailTemplatesAccessFull'], [7, 'QuestionnaireAccessFull'], [8, 'ProductAccessLevelSales'], [9, 'ProductAccessLevelSalesSenior'], [10, 'ProductAccessLevelCustomerService'], [11, 'SaleAgreementAccessFull'], [12, 'TaskflowAccessEdit'], [13, 'BetaUserAccess'], [14, 'EditAccountingPlan'], [15, 'CreateProductPlanManually'], [16, 'StartProductPlanManually'], [17, 'AccountingPlanSetupAccessFull'], [18, 'CreateCreditMemo'], [19, 'EditPriceAdjustments'], [20, 'EditMicrosoft365'], [21, 'ExportLedgerPosts'], [22, 'EditCompanyAccountingSettings'], [23, 'UpdateCompanyFromCvr'], [24, 'UpdateAccountingPlanStatus'], [25, 'CreateFreeMicrosoft365'], [26, 'EditProductPlanSettings'], [27, 'EditLedgerPosts'], [28, 'EditLanguageTranslations'], [29, 'EditAccountingPlanEndDate'], [30, 'EditMigratedLedgerPosts'], [31, 'SearchAccountingPlans'], [32, 'ProductPlanCompanyTransfer'], [33, 'EditProductPlanParent'], [34, 'CreateInvoiceObjection'], [35, 'SearchInvoiceObjections'], [36, 'EditReasons'], [37, 'EditSettlements'], [38, 'SystemIntegration'], [39, 'EditInvoiceOnHoldStatus'], [40, 'ManageCompanySites'], [41, 'DebtCollection'], [42, 'EditInvoiceDueDate'], [43, 'UpdateCompanyVatNumber'], [44, 'ManageSales'], [45, 'CancelApprovedOrders'], [46, 'ManageCommission'], [47, 'ManageCompanyFiles'], [48, 'ApproveSettlement'], [49, 'DeleteContracts'], [50, 'EditSalesDetails'], [51, 'ListOrdersWithCancellationWarnings'], [52, 'AccountingsystemSendDocuments'], [53, 'EditProductPlanTerminationNoticePeriod'], [54, 'AccessCompanyDomains'], [55, 'EditOrderSpecialConditions'], [56, 'AccessDebugViews'], [57, 'SyncEnvironmentData'], [58, 'EditDnsRecords'], [59, 'RequestRegistrarManagement'], [60, 'DomainCleanUp'], [61, 'DomainRedelegate'], [62, 'SearchProductPlans'], [63, 'ListOrdersForApproval'], [64, 'DebtCollectionRegisterAndExport'], [65, 'EditInvoiceInstallmentPayments'], [66, 'DashbordAccessFull']]);
	}
}
